import React, { useCallback } from 'react';
import ModalBanner from '../../ModalBanner';
import Close from '../../Reutilizaveis/CloseButton';
import styled from 'styled-components';

import useWindowDimension from '../../../hooks/WindowDimension';
import { isSafari, isDesktop } from 'react-device-detect';
import MessagePopup from '../../MessagePopup';
import './styles.scss';
import { ButtonPrimary } from '../../StyledComponent';

const ShowBoleto = ({
  showPdfBoleto,
  setShowPdfBoleto,
  base64PdfBoleto,
  pdfBoleto,
  vencimentoBoleto,
  tema,
}) => {
  const dimensions = useWindowDimension();

  const handleCloseMobilePopup = useCallback(() => {
    setShowPdfBoleto(false);
  }, []);

  const ContainerPdfDesktop = styled.div`
    display: block;
  `;

  const CloseBtn = styled.span`
    position: absolute;
    right: -15px;
    top: 0;
    cursor: pointer;
    @media (max-width: 768px) {
      right: 0px;
      top: -5px;
    }
  `;

  return isDesktop && !isSafari ? (
    <ModalBanner showBanner={showPdfBoleto} setShowBanner={setShowPdfBoleto}>
      <div className='centralized'>
        <div style={{ position: 'relative' }}>
          <CloseBtn
            onClick={() => {
              setShowPdfBoleto(false);
            }}
            id='btnFecharVisualizarBoleto'
          >
            <Close corBackground='#ffffff' tamanho='35px' />
          </CloseBtn>
          <ContainerPdfDesktop>
            <embed
              ref={pdfBoleto}
              src={`data:application/pdf;base64,${base64PdfBoleto}`}
              type='application/pdf'
              width='650'
              height={dimensions.winHeight > 700 ? 700 : 550}
              className='pdfBoletoDesktop'
            />
          </ContainerPdfDesktop>
        </div>
      </div>
    </ModalBanner>
  ) : (
    <MessagePopup
      isError
      title={'Parece que este navegador não suporta esta funcionalidade'}
      message={'Clique no botão abaixo para fazer download do boleto'}
    >
      <ButtonPrimary
        light
        tema={tema}
        fullWidth
        onClick={handleCloseMobilePopup}
      >
        Cancelar
      </ButtonPrimary>
      <ButtonPrimary tema={tema} fullWidth onClick={handleCloseMobilePopup}>
        <a
          href={`data:application/pdf;base64,${base64PdfBoleto}`}
          download={`Boleto Pode Morar vencimento: ${vencimentoBoleto}`}
        >
          BAIXAR BOLETO
        </a>
      </ButtonPrimary>
    </MessagePopup>
  );
};

export default ShowBoleto;
